import { Container, Typography, Button, Box, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { PictureAsPdf, Print } from '@mui/icons-material'
import { red } from '@mui/material/colors'
import styles from './trackingPDFButtonsStyles'
import { notification } from '../../../utils/Notifications'

const TrackingPDFButtons = ({pdfLink, termicaLink, isLoadingLinks, trackingCode}) => {
  const [isLoadingCarta, setIsLoadingCarta] = useState(false);
  const [isLoadingTermica, setIsLoadingTermica] = useState(false);

  const handleDownloadPDFCarta = () => {
    if (!pdfLink || isLoadingCarta) {
      return;
    }

    setIsLoadingCarta(true);

    try {
      const link = document.createElement('a');
      link.href = pdfLink;
      link.setAttribute('target', '_blank');
      link.download = `Guia_${trackingCode}_Carta.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      notification({
        text: "PDF Carta abierta exitosamente",
        type: "success",
      });
    } catch (error) {
      notification({
        text: "Error al abrir el PDF Carta",
        type: "error",
      });
    } finally {
      setIsLoadingCarta(false);
    }
  }

  const handleDownloadPDFTermica = () => {
    if (!termicaLink || isLoadingTermica) {
      return;
    }

    setIsLoadingTermica(true);

    try {
      const link = document.createElement('a');
      link.href = termicaLink;
      link.setAttribute('target', '_blank');
      link.download = `Guia_${trackingCode}_Termica.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      notification({
        text: "PDF Térmica descargado exitosamente",
        type: "success",
      });
    } catch (error) {
      notification({
        text: "Error al descargar el PDF Térmica",
        type: "error",
      });
    } finally {
      setIsLoadingTermica(false);
    }
  }

  const hasPdfLink = pdfLink && typeof pdfLink === 'string' && pdfLink.trim() !== '';
  const hasTermicaLink = termicaLink && typeof termicaLink === 'string' && termicaLink.trim() !== '';

  if (isLoadingLinks && trackingCode) {
    return (
      <Container style={styles.mainContainer}>
        <Typography variant="h6" sx={styles.title}>Descargar PDF de la guía</Typography>
        <Box sx={styles.buttonsContainer}>
          <CircularProgress 
            size={36} 
            thickness={3.5}
            sx={{ color: red['A400'] }} 
          />
        </Box>
      </Container>
    );
  }

  if (!trackingCode || (!hasPdfLink && !hasTermicaLink)) {
    return null;
  }

  return (
    <Container style={styles.mainContainer}>
      <Typography variant="h6" sx={styles.title}>Descargar PDF de la guía</Typography>
      <Box sx={styles.buttonsContainer}>
        {hasPdfLink && (
          <Button
            variant="text"
            startIcon={isLoadingCarta ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : <PictureAsPdf />}
            onClick={handleDownloadPDFCarta}
            disabled={isLoadingCarta}
            sx={styles.activeButton}
          >
            Carta
          </Button>
        )}
        {hasTermicaLink && (
          <Button
            variant="text"
            startIcon={isLoadingTermica ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : <Print />}
            onClick={handleDownloadPDFTermica}
            disabled={isLoadingTermica}
            sx={styles.activeButton}
          >
            Térmica
          </Button>
        )}
      </Box>
    </Container>
  )
}

export default TrackingPDFButtons

